import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import Box from '../Box';
import InputWrapper from '../InputWrapper';
const TextArea = _ref => {
  let {
    input,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(InputWrapper, Object.assign({
    input: input
  }, rest), _ref2 => {
    let {
      error,
      ...inputRest
    } = _ref2;
    return /*#__PURE__*/React.createElement(Box, Object.assign({
      as: TextareaAutosize,
      async: true,
      sx: {
        borderColor: error ? 'error' : null
      },
      variant: "inputs.primary",
      width: "100%"
    }, inputRest, input));
  });
};
export default TextArea;